import * as Yup from 'yup';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Stack,
    TextField,
    Typography
} from '@mui/material';
import React, { useEffect } from 'react';
import { OpenModalHookType } from '@hooks/useOpenModal';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { InputCategory } from '@api/InputCategories/InputCategory';

interface ModalSaveInputCategoryProps {
    modalSaveInputCategory: OpenModalHookType;
    inputCategory?: InputCategory;
    onSaveInputCategory: (inputCategory: InputCategory) => void;
}

const saveInputCategorySchema = Yup.object({
    id: Yup.string(),
    name: Yup.string().required('Nombre requerido')
});

export const ModalSaveInputCategory: React.FunctionComponent<ModalSaveInputCategoryProps> = (props) => {
    const { modalSaveInputCategory, inputCategory, onSaveInputCategory } = props;

    const {
        control,
        handleSubmit,
        reset,
        watch,
        formState: { errors }
    } = useForm<InputCategory>({
        resolver: yupResolver(saveInputCategorySchema)
    });

    const handleClose = () => {
        modalSaveInputCategory.toggle();
    };

    const onSaveForm: SubmitHandler<InputCategory> = async (values) => {
        onSaveInputCategory(values);
    };

    useEffect(() => {
        if (modalSaveInputCategory.modalOpen) {
            reset({
                id: inputCategory?.id || undefined,
                name: inputCategory?.name || ''
            });
        }
    }, [modalSaveInputCategory.modalOpen, inputCategory, reset]);

    return (
        <Dialog
            PaperProps={{
                style: { borderRadius: 15, padding: 4 }
            }}
            open={modalSaveInputCategory.modalOpen}
            onClose={handleClose}
            aria-labelledby="modal-save-input-category-title"
            aria-describedby="modal-save-input-category-description"
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle id="modal-save-input-category-title">
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6" fontWeight={600}>
                        {watch('id') ? 'Editar categoría' : 'Nueva categoría'}
                    </Typography>
                    <IconButton color="secondary" onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </Stack>
            </DialogTitle>
            <DialogContent>
                <form id="add-input-category-form" onSubmit={handleSubmit(onSaveForm)}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography variant="subtitle2">
                                Completa los datos para {watch('id') ? 'editar' : 'agregar'} una categoría de insumo
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Controller
                                name="name"
                                control={control}
                                render={({ field: { onChange, value } }) => (
                                    <TextField
                                        fullWidth
                                        required
                                        label="Nombre de la categoría"
                                        variant="outlined"
                                        value={value}
                                        onChange={onChange}
                                        error={!!errors.name}
                                        helperText={errors.name && errors.name.message}
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                </form>
            </DialogContent>
            <DialogActions>
                <Box flex={1} textAlign="center">
                    <Button
                        sx={{ width: 300 }}
                        color="primary"
                        variant="contained"
                        type="submit"
                        form="add-input-category-form"
                    >
                        Guardar
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
};
